module.exports = __webpack_public_path__ + "assets/img/hide.07e9a11f.svg";